(function () {
    'use strict';
    angular
        .module('tikonApp')
        .factory('AccountClearingRequestCustom', AccountClearingRequestCustom);

    AccountClearingRequestCustom.$inject = ['$resource'];

    function AccountClearingRequestCustom($resource) {


        var getActiveCompanyAccountClearingRequest = function () {
            var resourceUrl = 'api/get-active-company-account-clearing-request';
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: false}
                }
            );
        };

        var createNewAccountClearingRequest = function () {
            var resourceUrl = 'api/create-new-account-clearing-request';
            return $resource(resourceUrl, {}, {}
            );
        };

        var getAllClearanceRequests = function () {
            var resourceUrl = 'api/get-all-clearance-requests';
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: true}
                }
            );
        };


        return {
            getActiveCompanyAccountClearingRequest: getActiveCompanyAccountClearingRequest,
            createNewAccountClearingRequest: createNewAccountClearingRequest,
            getAllClearanceRequests: getAllClearanceRequests
        };
    }
})();
